import { ReferralBonusMap } from './referralBonusAction';

const initialState = {
    isLoading: false,
    refreshReferralBonus: true,
    referralBonusList: null,
    selectedReferralBonus: {},
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ReferralBonusMap.CREATE_REFERRAL_BONUS_START: {
            return { ...state, isLoading: true }
        }
        case ReferralBonusMap.CREATE_REFERRAL_BONUS_SUCCESS: {
            return { ...state, refreshReferralBonus: true }
        }
        case ReferralBonusMap.CREATE_REFERRAL_BONUS_ERROR: {
            return { ...state, isLoading: false }
        }
        case ReferralBonusMap.GET_ALL_REFERRAL_BONUS_START: {
            return { ...state, isLoading: true }
        }
        case ReferralBonusMap.GET_ALL_REFERRAL_BONUS_SUCCESS: {
            return { ...state, isLoading: false, refreshReferralBonus: false, referralBonusList: action.payload || {} }
        }
        case ReferralBonusMap.GET_ALL_REFERRAL_BONUS_ERROR: {
            return { ...state, isLoading: false, refreshReferralBonus: false }
        }
        case ReferralBonusMap.UPDATE_REFERRAL_BONUS_START: {
            return { ...state, isLoading: true }
        }
        case ReferralBonusMap.UPDATE_REFERRAL_BONUS_SUCCESS: {
            return { ...state, refreshReferralBonus: true, selectedReferralBonus: { ...state.selectedReferralBonus, ...action.payload } }
        }
        case ReferralBonusMap.UPDATE_REFERRAL_BONUS_ERROR: {
            return { ...state, isLoading: false }
        }
        case ReferralBonusMap.SET_SELECTED_REFERRAL_BONUS: {
            return { ...state, selectedReferralBonus: action.payload }
        }
        case ReferralBonusMap.REFRESH_REFERRAL_BONUS_LIST: {
            return { ...state, refreshReferralBonus: true }
        }
        default: return { ...state }
    }
} 